import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppUserProfileResponse } from '../models/auth.model';

export interface UpdateAppUserProfileRequest {
   Name: string;
   CellPhone: string;
   DocumentNumber: string;
   BirthDate?: string;
   Photo?: string;
}

@Injectable({ providedIn: 'root' })
export class AppUserProfileService {
   private readonly baseUrl = this.buildBaseUrl();

   constructor(private http: HttpClient) {}

   get(): Observable<AppUserProfileResponse> {
      return this.http.get<AppUserProfileResponse>(this.baseUrl);
   }

   update(request: UpdateAppUserProfileRequest): Observable<AppUserProfileResponse> {
      return this.http.put<AppUserProfileResponse>(this.baseUrl, request);
   }

   private buildBaseUrl(): string {
      const root = environment.apiBaseUrl.endsWith('/') ? environment.apiBaseUrl : `${environment.apiBaseUrl}/`;
      const prefix = (environment.apiPathPrefix || 'api/v1').replace(/^\/+|\/+$/g, '');
      return `${root}${prefix}/AppUserProfile/me`;
   }
}
